import { format } from 'util';
import { Layer } from '../../../models/layer-settings';
import { createWmsGetMapUrl } from './wms-utils';

export const tileJSON = (attrs, minZoom, maxZoom) => ({
  scheme: 'xyz',
  name: 'Fulcrum',
  description: 'Fulcrum',
  version: '2.0.0',
  tilejson: '2.1.0',
  minzoom: minZoom,
  maxzoom: maxZoom,
  ...attrs,
});

export const fulcrumPNGLayer = (layer: Layer, token) => format(
  '%s/tile/%s/%s/{z}/{x}/{y}@2x.png?q=%s&updated=%s',
  layer.baseURL,
  token || '-',
  layer.form,
  encodeURIComponent(layer.filter || ''),
  layer.lastUpdated,
);

export const fulcrumJSONLayer = (layer: Layer, token) => format(
  '%s/tile/%s/%s/{z}/{x}/{y}.json?jsonp=0&q=%s&updated=%s',
  layer.baseURL,
  token || '-',
  layer.form,
  encodeURIComponent(layer.filter || ''),
  layer.lastUpdated,
);

export const fulcrumMBTilesPNGLayer = (layer: Layer, token) => format(
  '%s/tile/mbtiles/%s/%s/{z}/{x}/{y}@2x.png',
  layer.baseURL,
  token || '-',
  layer.layerID,
);

export const fulcrumMBTilesJSONLayer = (layer: Layer, token) => format(
  '%s/tile/mbtiles/%s/%s/{z}/{x}/{y}.json?jsonp=0',
  layer.baseURL,
  token || '-',
  layer.layerID,
);

export const getTileUrl = (url) => (coord, zoom) => url
  .replace('{x}', coord.x)
  .replace('{y}', coord.y)
  .replace('{z}', zoom);

export const getWmsTileUrl = (url) => (coord, zoom) => {
  try {
    return createWmsGetMapUrl(url, coord.x, coord.y, zoom);
  } catch (error) {
    console.error(error);
    return '';
  }
};
